import { Box, Drawer, IconButton, Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { IoClose } from 'react-icons/io5';

export default function UpsellCrossSellFormSkeleton() {
  return (
    <Drawer
      anchor='right'
      open
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 400, md: 720 },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 100001
        }
      }}
    >
      {/* Header */}
      <Box
        px={3}
        py={2}
        borderBottom='1px solid #DEDEDE'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
      >
        <Skeleton variant='text' width={240} height={28} />
        <IconButton size='small' disabled>
          <IoClose size={24} />
        </IconButton>
      </Box>

      {/* Body */}
      <Box sx={{ flex: 1, overflowY: 'auto', p: 3 }}>
        <Grid container spacing={2}>
          {/* Select Menu */}
          <Grid size={6}>
            <Skeleton variant='rectangular' height={56} />
          </Grid>

          {/* Select Item */}
          <Grid size={6}>
            <Skeleton variant='rectangular' height={56} />
          </Grid>
        </Grid>

        {/* Upsell & Cross Sell Section */}
        <Grid container spacing={2} mt={2}>
          {/* Upsell */}
          <Grid size={6}>
            <Box border='1px solid #ECECEC' borderRadius='6px' p={2}>
              <Skeleton variant='text' width={160} height={24} sx={{ mb: 2 }} />

              {[1, 2].map((_, index) => (
                <Skeleton key={index} variant='rectangular' height={56} sx={{ mb: 1.5 }} />
              ))}

              <Box display='flex' justifyContent='center' mt={1}>
                <Skeleton variant='rectangular' width={120} height={36} />
              </Box>
            </Box>
          </Grid>

          {/* Cross Sell */}
          <Grid size={6}>
            <Box border='1px solid #ECECEC' borderRadius='6px' p={2}>
              <Skeleton variant='text' width={180} height={24} sx={{ mb: 2 }} />

              {[1, 2].map((_, index) => (
                <Skeleton key={index} variant='rectangular' height={56} sx={{ mb: 1.5 }} />
              ))}

              <Box display='flex' justifyContent='center' mt={1}>
                <Skeleton variant='rectangular' width={120} height={36} />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Footer */}
      <Box px={3} py={2} borderTop='1px solid #DEDEDE' display='flex' justifyContent='flex-end' gap={2}>
        <Skeleton variant='rectangular' width={100} height={36} />
        <Skeleton variant='rectangular' width={120} height={36} />
      </Box>
    </Drawer>
  );
}
